import React from 'react';
import styles from './InfoModal.module.scss';
import { Helpdesk } from 'models/Helpdesk/helpdesk.model';
import LoaderAnimation from '../LoaderAnimation';
import OrganizationModal from '../OrganizationModal';

export interface InfoModalProps {
  showModalState: boolean;
  handleModalCancel: () => void;
  data: Helpdesk | null;
  loading: boolean;
}

const InfoModal: React.FC<InfoModalProps> = ({
  showModalState,
  handleModalCancel,
  data,
  loading,
}: InfoModalProps) => {
  return (
    <OrganizationModal
      visible={showModalState}
      onClose={handleModalCancel}
      title={data?.input_field}
      wrapClassName={styles.infoModalWrapper}
      width={450}
      children={
        <div className={styles.mainContainer}>
          {loading ? (
            <div className={styles.loaderContainer}>
              <LoaderAnimation />
            </div>
          ) : data ? (
            <>
              <div className={styles.contentContainer}>
                <h3 className={styles.contentHeader}>What</h3>
                <h4>{data?.what}</h4>
                {data?.why && (
                  <>
                    <h3>Why</h3>
                    <h4>{data?.why}</h4>
                  </>
                )}
                {data?.tips && (
                  <>
                    <h3>Tips</h3>
                    <h4>{data?.tips}</h4>
                  </>
                )}
              </div>
            </>
          ) : (
            <div className={styles.noDataAvailable}>No Data Available</div>
          )}
        </div>
      }
    />
  );
};

export default InfoModal;
